// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__MuNeK","containerItemsCenter":"Skeleton_containerItemsCenter__3SIp1"};